import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InputsModule } from "@progress/kendo-angular-inputs";
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";
import { MatSelectModule } from '@angular/material/select';

import { DropDownsModule } from "@progress/kendo-angular-dropdowns";

// components
import { DynamicFormBuilderComponent } from './dynamic-form-builder/dynamic-form-builder.component';
import { FieldBuilderComponent } from './field-builder/field-builder.component';

import { CheckBoxComponent } from './field-controls/checkbox/checkbox';
import { RadioComponent } from './field-controls/radio/radio.component';
import { DateComponent } from './field-controls/date/date.component';
import { TextboxComponent } from './field-controls/textbox/textbox.component';
import { DropdownComponent } from './field-controls/dropdown/dropdown.component';
import { MatrixComponent } from './field-controls/matrix/matrix.component';
import { TimeComponent } from './field-controls/time/time.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputsModule,
    DateInputsModule,
    MatSelectModule,

    DropDownsModule
  ],
  declarations: [
    DynamicFormBuilderComponent,
    FieldBuilderComponent,
    DateComponent,
    CheckBoxComponent,
    RadioComponent,
    TextboxComponent,
    DropdownComponent,
    MatrixComponent,
    TimeComponent
  ],
  exports: [
    DynamicFormBuilderComponent,
    FieldBuilderComponent,
    DateComponent,
    CheckBoxComponent,
    RadioComponent,
    TextboxComponent,
    DropdownComponent,
    MatrixComponent,
    TimeComponent
  ],
  providers: []
})
export class DynamicFormBuilderModule { }
